import React from 'react';
import { bool, func, object, shape, string } from 'prop-types';
import Overlay from '@ynap/overlay';
import BEMHelper from '@ynap/bem-helper';
import ReactMarkdown from 'markdown-to-jsx';
import PriceInformationCard from './PriceInformationCard/PriceInformationCard';

const bem = new BEMHelper('PriceInformationModal');

const PriceInformationModal = (props) => {
    const {
        messages,
        closeModal,
        locale = 'en-gb',
        termsAndConditionsPath = '',
        product,
        config: { head: { omnibusROWEnabled, minimumPriceCountries = [] } = {} } = {},
        country,
        omnibusConfig,
    } = props;

    const { designerName, badges: { selectedProductColorFirstBadge } = {}, price } = product || {};

    const isEUcountry = minimumPriceCountries.includes(country?.toUpperCase?.());
    const showMinimumPriceLabel = isEUcountry && typeof price?.minimumPrice === 'number';
    const privateLabel = designerName === 'IRIS & INK' || selectedProductColorFirstBadge?.key === 'BADGE_EXCLUSIVE';

    const {
        price: {
            priceInformation: {
                title = () => '',
                descriptionRRP = () => '',
                descriptionOriginalPrice = () => '',
                descriptionOriginalPriceWithoutMinimumMessage = () => '',
                descriptionRRPWithoutMinimumMessage = () => '',
                descriptionThirdPartyUs = () => '',
                subtitle = () => '',
                paragraph = () => '',
            } = {},
        } = {},
    } = messages;

    const privateLabelWithoutMinimumPrice = privateLabel && !showMinimumPriceLabel && omnibusROWEnabled;
    const privateLabelWithMinimumPrice = privateLabel && showMinimumPriceLabel && omnibusROWEnabled;
    const thirdPartyWithoutMinimumPrice = !privateLabel && !showMinimumPriceLabel && omnibusROWEnabled && country !== 'US';
    const thirdPartyWithMinimumPrice = !privateLabel && showMinimumPriceLabel && omnibusROWEnabled;
    const thirdPartyWithoutMinimumPriceUS = !privateLabel && !showMinimumPriceLabel && omnibusROWEnabled && country === 'US';
    const discountPercentage = price?.discountPercentage;

    const popUpDescription = () => {
        if (privateLabelWithoutMinimumPrice) {
            return descriptionOriginalPriceWithoutMinimumMessage({ link: `${window.location.origin}${termsAndConditionsPath.replace(':locale', locale)}` });
        }
        if (thirdPartyWithoutMinimumPrice) {
            return descriptionRRPWithoutMinimumMessage({ link: `${window.location.origin}${termsAndConditionsPath.replace(':locale', locale)}` });
        }
        if (privateLabelWithMinimumPrice) {
            return descriptionOriginalPrice({ link: `${window.location.origin}${termsAndConditionsPath.replace(':locale', locale)}` });
        }
        if (thirdPartyWithMinimumPrice) {
            return descriptionRRP({ link: `${window.location.origin}${termsAndConditionsPath.replace(':locale', locale)}` });
        }
        if (thirdPartyWithoutMinimumPriceUS) {
            return descriptionThirdPartyUs({ link: `${window.location.origin}${termsAndConditionsPath.replace(':locale', locale)}` });
        }
    };

    if (omnibusConfig) {
        const markdownContent = paragraph({ link: `${window.location.origin}${termsAndConditionsPath.replace(':locale', locale)}` });
        return (
            <Overlay data-testid="PriceInformationModal" onClose={closeModal} title={title()} type={'positionModifier'}>
                <div className={bem('paragraph')}>
                    <ReactMarkdown>{markdownContent}</ReactMarkdown>
                </div>
            </Overlay>
        );
    }

    return (
        <Overlay className={bem()} data-testid="PriceInformationModal" onClose={closeModal} title={title()} contentModifier={'contentModifier'}>
            <h2 className={bem('title')}>{subtitle()}</h2>
            <PriceInformationCard
                price={product?.price}
                messages={messages}
                locale={locale}
                privateLabel={privateLabel}
                isEUcountry={isEUcountry}
                showMinimumPriceLabel={showMinimumPriceLabel}
                privateLabelWithMinimumPrice={privateLabelWithMinimumPrice}
                thirdPartyWithMinimumPrice={thirdPartyWithMinimumPrice}
                discountPercentage={discountPercentage}
                {...props}
            />
            <ReactMarkdown className={bem('markdownContainer', thirdPartyWithoutMinimumPriceUS && 'UsCountryModifier')}>{popUpDescription()}</ReactMarkdown>
        </Overlay>
    );
};

PriceInformationModal.propTypes = {
    closeModal: func.isRequired,
    messages: shape({
        title: func,
        description: func,
    }),
    locale: string,
    config: object,
    country: string,
    product: object,
    termsAndConditionsPath: string,
    omnibusConfig: bool,
};

export default PriceInformationModal;
